import { INT_MAX_SIGNED_32_BIT_VALUE } from '../../globals/globals';

export default class Color {
  label?: string;
  ordinal?: number;

  constructor(label: string, ordinal: number) {
    this.label = label;
    this.ordinal = ordinal;
  }
}

export const ColorChoices = {
  WHITE: new Color('Wit', 0),
  BLACK: new Color('Zwart', 1),
  GRAY: new Color('Grijs', 2),
  OTHER: new Color('Andere', INT_MAX_SIGNED_32_BIT_VALUE)
};
